import React, { useEffect, useRef, useState } from "react";
import styles from "./ORA_input.module.css";
import axios from "axios";

const ORAinput = ({
  setLoading,
  ORAType,
  CGdbType,
  dbType,
  setDBType,
  geneSetType,
  setGeneSetType,
  geneSet,
  setGeneSet,
  setGeneSetLength,
  qValueCutoff,
  setQValueCutoff,
  setErr,
  setCancerLevelSet,
  cancerLevelSet,
  setResultData,
  sepBtnState,
  setSepBtnState,
  selectedFileForPathwayDB,
  setSelectedFileForPathwayDB,
  exampleGeneset
}) => {

  const [GSEAClicked, setGSEAClicked] = useState(false);
  const handleSelectDB = (db) => {
    setDBType(db);
  };
  const handleGeneSetType = (type) => {
    setGeneSetType(type);
  };
  const handleSetGenes = (e) => {
    let text = e.target.value;
    text = text.replaceAll(" ", "");
    if (text.includes(";")) {
      text = text.replaceAll(";", "\n");
    }
    if (text.includes(",")) {
      text = text.replaceAll(",", "\n");
    }
    setGeneSet(text);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFileForPathwayDB(file);
      
    }
  };

  const uploadFile = () => {
    let formData = new FormData();
    if (selectedFileForPathwayDB) {
      formData.append("file", selectedFileForPathwayDB);
      formData.append('geneSetType', geneSetType);
      formData.append('dbType', dbType);
      formData.append('geneSet', geneSet.replaceAll("\n", ",").trim());
      formData.append('qValueCutoff', qValueCutoff);
      formData.append('cancerLevel', cancerLevelSet);
      formData.append('CGdbType', CGdbType);
    }
    window.scrollTo(0, 0);
    setLoading(true);
    setSepBtnState("");
    const headers = {
      'accept': "*/*",
      'Content-Type': 'multipart/form-data'
    };
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/ora-upload`,
      headers,
      data: formData
    })
      .then((res) => {
        const resultData = JSON.parse(res.data.data);
        const resultData_array = Object.values(resultData);
        setResultData(sortByKey(resultData_array, "qval"));
        localStorage.setItem("countDB", JSON.stringify(res.data.countDB));
        localStorage.setItem("intersec_ORA", res.data.matchInfo.intersec);
        localStorage.setItem("total_ORA", res.data.matchInfo.total);
        localStorage.setItem("percent_ORA", res.data.matchInfo.percent);
      })
      .then(() => {
        setLoading(false);
        setErr(false);
        setSepBtnState("Result_table");
      })
      .catch((error) => {
        setLoading(false);
        setErr(true);
        alert(
          "❌ An error has occurred because the input format is not correct. Please check again!"
        );
      });
  };

  const handleSubmit = () => {
    if (
      dbType === "" ||
      geneSetType === "" ||
      geneSet === "" ||
      qValueCutoff === "" ||
      cancerLevelSet === ""
    ) {
      alert("❗️Please input all the data!");
      return;
    }

    if (dbType === "user-defined") {
      uploadFile();
      return;
    }

    setGeneSetLength(geneSet.split('\n').length)
    window.scrollTo(0, 0);
    setLoading(true);
    setSepBtnState("");
    const headers = {
      accept: "*/*",
    };
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/ora`,
      headers,
      data: {
        geneSetType,
        dbType,
        geneSet: geneSet.replaceAll("\n", ",").trim(),
        qValueCutoff,
        cancerLevel: cancerLevelSet,
        CGdbType,
      },
    })
      .then((res) => {
        const resultData = JSON.parse(res.data.data);
        const resultData_array = Object.values(resultData);
        const curated_array = resultData_array.map(item =>(
          {
            ...item,
            pvalue : parseFloat(item.pvalue_string),
            qval : parseFloat(item.qvalue)
          }
        ))
        setResultData(sortByKey(curated_array, "qval"));
        localStorage.setItem("countDB", JSON.stringify(res.data.countDB));
        localStorage.setItem("intersec_ORA", res.data.matchInfo.intersec);
        localStorage.setItem("total_ORA", res.data.matchInfo.total);
        localStorage.setItem("percent_ORA", res.data.matchInfo.percent);
      })
      .then(() => {
        setLoading(false);
        setErr(false);
        setSepBtnState("Result_table");
      })
      .catch((error) => {
        setLoading(false);
        setErr(true);
        alert(
          "❌ An error has occurred because the input format is not correct. Please check again!"
        );
      });
  };

  const generateTestValues = () => {
    setGeneSetType("str");
    setGeneSet(exampleGeneset);
  };

  const qValueCutoffList = [
    {
      name: "cut off < 0.001 (Default)",
      data: "q_0001_val",
    },
    {
      name: "cut off < 0.01",
      data: "q_001_val",
    },
    {
      name: "cut off < 0.05",
      data: "q_005_val",
    },
  ];

  const cancerLevelList = [
    {
      name: "level 1 (Default)",
      data: "1",
    },
    {
      name: "level 1 and 2",
      data: "1&2",
    },
    {
      name: "level 1,2 and 3",
      data: "1&2&3",
    },
    {
      name: "level 1,2,3 and 4",
      data: "1&2&3&4",
    },
  ];

  useEffect(() => {}, [geneSetType]);

  return (
    <div className={styles.section}>
        <h1 className={styles.mainTitle}>◼️ Over-Representation Analysis ({ORAType})</h1>
      <div className={styles.container}>
        <div className={styles.inputCnts} style={{marginRight :'80px', border : '2px solid lightgrey', padding :'15px 30px 30px 30px', borderRadius :'10px'}}>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>1</span>Select Pathway Databases
            </h4>
            <div className={styles.btnCnt}>
              <button
                className={styles.button}
                onClick={() => {
                  setGSEAClicked(true);
                  setDBType("");
                }}
              >
                MSigDB
              </button>
              <button
                className={`${styles.button} ${
                  dbType === "CPDB" ? styles.selected : ""
                }`}
                onClick={() => {
                  handleSelectDB("CPDB");
                  setGSEAClicked(false);
                }}
              >
                CPDB
              </button>
              <button
                className={`${styles.button} ${
                  dbType === "user-defined" ? styles.selected : ""
                }`}
                onClick={() => {
                  handleSelectDB("user-defined");
                  setGSEAClicked(false);
                }}
              >
                User Defined
              </button>
            </div>

            {/* GSEA - H, C1~C8  */}
            {GSEAClicked && (
              <div className={styles.btnCnt2}>
                <div className={styles.line}></div>
                <button
                  className={`${styles.button} ${
                    dbType === "H" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("H")}
                >
                  MSigDB(H)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C1" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C1")}
                >
                  MSigDB(C1)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C2" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C2")}
                >
                  MSigDB(C2)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C3" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C3")}
                >
                  MSigDB(C3)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C4" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C4")}
                >
                  MSigDB(C4)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C5" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C5")}
                >
                  MSigDB(C5)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C6" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C6")}
                >
                  MSigDB(C6)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C7" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C7")}
                >
                  MSigDB(C7)
                </button>
                <button
                  className={`${styles.button} ${
                    dbType === "C8" ? styles.selected : ""
                  }`}
                  onClick={() => handleSelectDB("C8")}
                >
                  MSigDB(C8)
                </button>
              </div>
            )}

            {/* file Upload for User Defined */}
            {dbType === "user-defined" && (
              <div className={styles.btnCnt2}>
                <div className={styles.line}></div>
                <input 
                type="file" 
                onChange={handleFileUpload} 
                accept=".csv, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                <table className={styles.exampleTable}>
                  <tr>
                    <th>pathway</th>
                    <th>source</th>
                    <th>geneList</th>
                  </tr>
                  <tr>
                    <td>pathway1</td>
                    <td>NA</td>
                    <td>gene1;gene2;gene3</td>
                  </tr>
                  <tr>
                    <td>pathway2</td>
                    <td>KEGG</td>
                    <td>gene4;gene5;gene6</td>
                  </tr>
                </table>
              </div>
            )}
          </div>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>2</span>
              Select gene identifier type
            </h4>
            <div className={styles.btnCnt}>
              <button
                className={`${styles.button} ${
                  geneSetType === "str" ? styles.selected : ""
                }`}
                onClick={() => handleGeneSetType("str")}
              >
                HGNC symbol
              </button>
              <button
                className={`${styles.button} ${
                  geneSetType === "int" ? styles.selected : ""
                }`}
                onClick={() => handleGeneSetType("int")}
              >
                Entrez ID
              </button>
            </div>
          </div>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>3</span>Input user defined gene
              set&nbsp;
              <span
                style={{
                  color: "blue",
                  fontWeight: "400",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={generateTestValues}
              >
                (example)
              </span>
            </h4>
            <textarea
              placeholder={
                geneSetType === "int"
                  ? "ex.1,2,3,4,..."
                  : "ex.RSPO3, KRAS, BRCA1, ZZZ3..."
              }
              className={styles.input}
              onChange={(e) => handleSetGenes(e)}
              value={geneSet === exampleGeneset ? exampleGeneset : geneSet}
            />
          </div>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>4</span>Select {ORAType === 'Cancer' ? 'cancer' : ORAType === 'Immune' ? 'immune' : ''} association level of pathways
            </h4>
            <Dropdown
              setValue={setCancerLevelSet}
              dropdownList={cancerLevelList}
            />
          </div>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>5</span>Select the cutoff p-value for
              gene set size-adjusted FDR control
            </h4>
            <Dropdown
              setValue={setQValueCutoff}
              dropdownList={qValueCutoffList}
            />
          </div>
          <div className={styles.submitBtnCnt}>
            <button className={styles.submitBtn} onClick={handleSubmit}>
              Analyze
            </button>
          </div>
        </div>
      
        <div className={styles.desCnt}>
          {/* <h1 className={styles.mainTitle}>◼️ ORA Analysis (Cancer)</h1> */}
          <p className={styles.desc}>
            <span style={{ fontWeight: "bold" }}>
              Over-representation analysis&nbsp;
            </span>
            was conducted using a hypergeometric test with FDR control based on gene set size,
            employing an extensive permutation test.
            We gathered 4,681 biological pathways from 11 commonly used databases 
            (KEGG, Biocarta, Reactome, PID, Wikipathways, NetPath, INOH, Signalink, SMPDB, ENMN, and HumanCyc) 
            from ConsensusPathDB (CPDB) and 33,196 gene sets (H, C1 - C8) from GSEA MSigDB.
          </p>
          <p className={styles.details}>Details</p>
        </div>

      
      
      </div>
    </div>
  );
};

export default ORAinput;

const Dropdown = ({
  setValue,
  dropdownList,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const selectOption = (e) => {
    const target = e.target;
    typeof target.dataset.value === "string" && setValue(target.dataset.value);
    setSelectedOption(target.innerText);
    setShowDropdown(false);
  };

  return (
    <div className={styles.dropdown}>
      <button
        className={`${styles.dropBtn} ${
          selectedOption !== "" ? styles.clicked : ""
        } `}
        onClick={toggleDropdown}
      >
        {selectedOption === "" ? "Select" : selectedOption}
      </button>
      {showDropdown && (
        <ul className={styles.optionCnt}>
          {dropdownList.map((item, index) => (
            <li
              key={index}
              onClick={(e) => selectOption(e)}
              data-value={item.data}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

function sortByKey(arr, key) {
  return arr.sort((a, b) => a[key] - b[key]);
}
